module.exports = __webpack_public_path__ + "static/media/poster6.c0dcc693.jpg";